import Glide from '@glidejs/glide';

const sliderInstances = [];

export const getAll = () => document.querySelectorAll('.glide');

export const mountSliders = (sliders) => {
	if (sliders === null) return;

	for (let i = 0; i < sliders.length; i++) {
		sliderInstances.push(
			new Glide(sliders[i], {
				perView: 1,
				type: 'slider',
				gap: 0,
				rewind: true,
				observer: true,
				observeParents: true,
				keyboard: false,
			}).mount()
		);
	}
};

export const destroySliders = () => {
	sliderInstances.forEach((instance) => instance.destroy());
};

const init = () => {
	const sliders = getAll();

	mountSliders(sliders);

	$('a[data-toggle="tab"]').on('shown.bs.tab', () => {
		$(window).trigger('resize', {});

		window.dispatchEvent(new Event('resize'));
	});
};

init();
